import React from "react";

const NailSalonInJakkurCustomer = () => {
  return (
    <div className="hairSalonInJakkurCustomer">
      <h5>Client Experiences</h5>
      <p>
        Don’t just take our word for it – here’s what some of our clients have
        to say about their experiences at our Nail Salon in Jakkur:
      </p>
      <div className="hairSalonInJakkurCustomerContent">
        <p>
          <span className="quote">“</span>I’ve been coming to this Nail Salon in
          Jakkur for years, and I’m always impressed with the service. The
          technicians are friendly, professional, and truly know their craft. My
          nails always look amazing! <span className="quote">”</span> -{" "}
          <span>Sarah T. </span>
        </p>
        <p>
          <span className="quote">“</span>The Nail Salon in Jakkur is my go-to
          place for all things nails. The quality of their work is outstanding,
          and the atmosphere is so relaxing. Highly recommend their gel
          manicure!
          <span className="quote">”</span> - <span>John R . </span>
        </p>
      </div>
    </div>
  );
};

export default NailSalonInJakkurCustomer;
